/**
* ListSelect component
* extends List Component
*   purpose : items can be selected
* @ng-content: header
**/

import _findIndex from 'lodash-es/findIndex';
import _toString from 'lodash-es/toString';
import _keys from 'lodash-es/keys';
import _clone from 'lodash-es/clone';
import _remove from 'lodash-es/remove';
import _forEach from 'lodash-es/forEach';

//Angular Core
import { Component } from '@angular/core';
import { ListComponent } from '../list/list.component';

import { SelectService } from '../../service/select/select.service';

import { faEye, faEyeSlash, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({

    selector: 'list-select',
    templateUrl: 'listselect.html',
    styles: [
        `traveller-synchronyme ::ng-deep .list-item:hover{
            border-left-color: transparent;
        }
        `
    ]
})
export class ListSelectComponent extends ListComponent {


    public listData: any;

    public m_listItem: string[] = [];

    public m_disabled: number[] = [];

    public iconEye: IconDefinition = faEye;

    public iconEyeSlash: IconDefinition = faEyeSlash;

    public showTravellers: boolean = false;

    constructor(private readonly selectService: SelectService) {
        super();
        this.listData = selectService.data;
    }

    /**
     * isAllChecked
     * @return true if all items are checked
     */
    public isAllChecked(): boolean {
        let output: boolean;

        if (this.listData.list[this.listId].length === this.m_listItem.length) {
            output = true;
        } else {
            output = false;
        }

        return output;
    }

    /**
     * addRemoveAll
     * select / unselect All
     */
    public addRemoveAll(): void {

        if (this.listData.list[this.listId].length === this.m_listItem.length) {

            if (this.listData.listDisabled[this.listId] && this.listData.listDisabled[this.listId].length > 0) {
                this.listData.list[this.listId] = _clone(this.listData.listDisabled[this.listId]);
            } else if (!this.listData.listDisabled[this.listId] || this.listData.listDisabled[this.listId] === 0) {
                this.listData.list[this.listId] = [];
            }

        } else {
            this.listData.list[this.listId] = _keys(this.list);
        }

    }

    /**
     * isChecked
     * @param _id : item id
     * @returns {boolean} : true if item is checked
     */
    public isChecked(_id: any): boolean {
        let output: boolean;
        _id = _toString(_id);
        const index = _findIndex(this.listData.list[this.listId], (o: any) => o === _id);
        if (index > -1) {
            output = true;
        } else {
            output = false;
        }

        return output;
    }

    /**
     * isDisabled
     *
     * @param _id
     * @returns {boolean} : true if item is disabled
     */
    public isDisabled(_id: any): boolean {
        _id = _toString(_id);
        const index = _findIndex(this.listData.listDisabled[this.listId], (o: any) => o === _id);
        return index > -1;
    }

    /**
     * showPnr
     * Show the PNR associated
     * event emited
     * @param _event
     */
    public showPnr(_event: any): void {
        this.showItemEvent.emit(_toString(_event));
    }

    /**
     * addRemoveItem
     * add or remove the item on selection
     * @param _id
     */
    public addRemoveItem(_id: any): void {
        _id = _toString(_id);
        if (!this.isDisabled(_id)) {
            const index = _findIndex(this.listData.list[this.listId], (o: any) => o === _id);
            if (index > -1) {
                _remove(this.listData.list[this.listId], (n: any) => n === _id);
            } else {
                this.listData.list[this.listId].push(_id);
            }
        }
    }

    /**
     * init
     * launched from ngOnInit
     */
    protected init(): void {
        this.m_listItem = _keys(this.list);
        this.listData.list[this.listId] = [];

        // Test all itemms...
        _forEach(this.list, (value: any, key: any) => {
            const id = _toString(value.id);
            //Set preChecked items
            if (value[this.selectedIf]) {
                this.addRemoveItem(id);
            }

            //Set disabled items
            if (value[this.disabledIf]) {
                if (!this.listData.listDisabled[this.listId]) {
                    this.listData.listDisabled[this.listId] = [];
                }
                this.listData.listDisabled[this.listId].push(id);
            }
        });

        // if disabled items, add them to service
        if (this.m_disabled && this.m_disabled.length > 0) {
            this.listData.listDisabled[this.listId] = this.m_disabled;
        }

    }

}
